module.exports = __webpack_public_path__ + "static/media/user.673ac715.png";